import { RoomProvider } from '../components/video/RoomContext';
import RoomComponent from '../components/video/RoomComponent';

const Room = ({ roomId }) => (
  <RoomProvider>
    <RoomComponent roomId={roomId}/>
  </RoomProvider>
);

export default Room;